import { useContext } from "react";
import SelectedSubAccountContext from "src/contexts/SelectedSubAccountContext";

const useSelectedSubAccount = () => useContext(SelectedSubAccountContext);

export default useSelectedSubAccount;
